import { useCopyClipboard } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import Button from 'components/Button'
import content from 'prismic-translates/common.json'
import { useAppSelector } from 'store/hooks'
import { getUserCustomerIdSelector } from 'store/modules/user/selectors'
import { useThemeContext } from 'theme/themeProvider'
import { generateShareUlrWithUserId } from 'utils/url'

import classes from './styles.module.scss'

export default function ReferFriendsLinkOld() {
  const customerId = useAppSelector(getUserCustomerIdSelector)
  const shareUrl = generateShareUlrWithUserId(customerId)
  const { isDarkMode } = useThemeContext()
  const [isCopied, setClipboard] = useCopyClipboard(shareUrl, 10000)
  const t = getTranslationFromJson([content])

  return (
    <div className={cx(classes.root, isDarkMode && classes.rootDarkMode)} data-test='invite-friends-native-copy'>
      <p className={classes.shareUrl}>{shareUrl}</p>
      <div>
        <Button
          onClick={setClipboard}
          variant='contained'
          size='small'
          className={classes.button}
          data-test='invite-friends-copy-link-button'
        >
          {isCopied ? `✓ ${t('copied')}` : t('copy')}
        </Button>
      </div>
    </div>
  )
}
